import { AdminPageShell } from "../components/index.js";
import { QuizList } from "../features/quizzes/index.js";
import { useT } from "../i18n/index.js";

export function AdminQuizzesPage() {
  const t = useT();
  return (
    <AdminPageShell crumbs={[{ label: t("admin.quizzes") }]}>
      <QuizList />
    </AdminPageShell>
  );
}
